var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"triggers":['hover'],"aria-role":"list","position":"is-bottom-left"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('button',{staticClass:"button",class:{
        'is-success': _vm.invoice && _vm.invoice.status === 'emitted',
        'is-danger':
          _vm.invoice &&
          (_vm.invoice.status === 'error' || _vm.invoice.status === 'rejected'),
        'is-dark': _vm.invoice && _vm.invoice.status === 'cancelled',
        'is-warning': _vm.invoice && _vm.invoice.status === 'pending',
        'is-info': _vm.invoice && _vm.invoice.status === 'notApplicable'
      },attrs:{"slot":"trigger","disabled":_vm.invoice && _vm.invoice.status === 'notSent'},slot:"trigger"},[_vm._v("\n      "+_vm._s(_vm.invoice.status === "emitted"
          ? _vm.$t("transactions.emitted")
          : _vm.invoice.status === "pending"
          ? _vm.$t("transactions.pending")
          : _vm.invoice.status === "error"
          ? _vm.$t("transactions.error")
          : _vm.invoice.status === "rejected"
          ? _vm.$t("transactions.rejected")
          : _vm.invoice.status === "cancelled"
          ? _vm.$t("transactions.cancelled")
          : _vm.invoice.status === "notSent"
          ? _vm.$t("transactions.notSent")
          : _vm.invoice.status === "notEnabled"
          ? _vm.$t("transactions.notEnabled")
          : _vm.invoice.status === "notApplicable"
          ? _vm.$t("transactions.notApplicable")
          : "-")+"\n    ")])]},proxy:true}])},[_c('b-dropdown-item',{attrs:{"aria-role":"listitem"},on:{"click":function($event){return _vm.copyContent(_vm.transactionId, 'ID da transação copiado!')}}},[_c('b',[_vm._v("ID: ")]),_vm._v(_vm._s(_vm.transactionId)+"\n    "),_c('b-icon',{attrs:{"icon":"copy"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }